import DialogConfirmacao from "./DialogConfirmacao";

const DialogCancelar = ({ visible, onHide, onConfirm, loading }) => {
  return (
    <DialogConfirmacao
      visible={visible}
      onHide={onHide}
      onConfirm={onConfirm}
      message="Tem certeza que deseja cancelar esta agenda?"
      loading={loading}
      confirmText="SIM, CANCELAR"
      cancelText="NÃO"
      showWarning={true}
    />
  );
};

export default DialogCancelar;